import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=5d58ae55&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersTable.vue?vue&type=style&index=0&id=5d58ae55&prod&lang=scss&module=true"
import style1 from "./OrdersTable.vue?vue&type=style&index=1&id=5d58ae55&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5d58ae55",
  null
  
)

export default component.exports